import {EntityCollectionServiceBase} from "@ngrx/data";
import {PaginatedEntityCollectionReadOnlyService} from "./paginatedEntityCollectionReadOnlyService";
import {HttpModelConverter} from "../converter/httpModel.converter";
import {Sort, UrlParameter} from "../../../shared/utils/url.builder";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {DefaultDataservice} from "../../../store/core/dataservice/default.dataservice";

export abstract class SelectEntityCollectionReadOnlyService<T,  C extends HttpModelConverter<T>> extends PaginatedEntityCollectionReadOnlyService<T,C>{

    readonly entities$: Observable<T[]>;
    protected constructor(serviceName: string, entityCollectionServiceBase: EntityCollectionServiceBase<T>,
                          dataService: DefaultDataservice<T>,
                          converter: C, pageSize: number, sort?: Sort, urlParameters?: UrlParameter[]) {
        super(serviceName, entityCollectionServiceBase, dataService, converter, pageSize, sort, urlParameters);

        this.entities$ = this.page$.pipe(
            map(page => page ? page.content : [])
        );


    }

    protected coreFindAll(urlParameters?: UrlParameter[],  sort?: Sort) {
        super.firstPage(urlParameters, this.pageSize, sort);
    }
}
